<div class="wrapper"
(clickOutside)="close()"
[style.width]="showItems ? 'auto' : '25px'"
[ngClass]="{'grey-theme': theme === 'grey-theme' && !showItems}"
>
	<div class="item-container"
		[style.width]="showItems ? ((items.length * 30) + 10) + 'px' : '25px'">
		<bb-button
			*ngIf="includeAddButton"
			[hidden]="showItems"
			class="add-item-button"
			(click)="onAddButtonClick($event)"
			data-cy="add-item-button"
			icon="plus"
			[pxSize]="25"
			backgroundColor="blue"
			theme="dark"
			[round]="true"
		></bb-button>
		<ng-container *ngFor="let item of items; let i=index">
			<ng-container 
				*ngTemplateOutlet="buttonItem; context: {item:item}">
			</ng-container>
		</ng-container>
	</div>

	<div class="item-container extra-items"
		*ngIf="extraItems"
		[class.only-one]="extraItems.length === 1"
		[hidden]="!showItems">
		<ng-container *ngFor="let item of extraItems; let i=index">
			<ng-container 
				*ngTemplateOutlet="buttonItem; context: {item:item}">
			</ng-container>
		</ng-container>
	</div>
	<div class="add-label" [hidden]="!addLabel || showItems"
	(click)="onAddLabelClick()">
		<span [innerHTML]="addLabel"></span>
	</div>
</div>

<ng-template #buttonItem let-item="item">
	<div
		*ngIf="showItems"
		[hidden]="!showItems"
		[style.opacity]="itemOpacity"
		class="item"
		(click)="onItemClicked(item)" 
		(mouseover)="onItemHover(item)" 
		[attr.title]="item?.label"
		[attr.data-cy]="'button-action-' + item.label">
		<span
			*ngIf="!item?.icon && !item?.svgIcon"
			[innerHTML]="item?.value | widgetIcon"
		></span>
		<span
			*ngIf="item?.icon"
			><i [class]="'fa fa-' + item?.icon"></i>
		</span>
		<div
			*ngIf="item?.svgIcon"
			class="svg-icon"
			[style.background-image]="'url(' + item?.svgIcon + ')'"
		>
		</div>
	</div>
</ng-template>
